import { render, staticRenderFns } from "./ConfigAlertTelegram.vue?vue&type=template&id=e54da402&scoped=true"
import script from "./ConfigAlertTelegram.vue?vue&type=script&lang=js"
export * from "./ConfigAlertTelegram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54da402",
  null
  
)

export default component.exports